import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const useAllergies = (patientId) => {

  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["allergies", patientId, tenantVal],
    queryFn: async () => {
      if (!patientId) return null;
      const axiosInstance = await createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}/allergy/getbypatientid/${patientId}`
      );
      return response.data;
    },
    enabled: !!patientId,
    meta: { errorMessage: "Error fetching allergies" },
  });
};
